import React from "react";

import { Button } from "antd";

import { ReactComponent as LoadingDots } from "../../../../../../assets/images/common/LoadingDots.svg";
import "./SubmitButton.css";

export default function SubmitButton({
  loading,
  disabled,
  handleSaveTemplate,
  text,
}) {
  return (
    <Button
      htmlType="button"
      type="primary"
      className={`BuilderSave__ConfirmButton${disabled || loading ? " BuilderSave__ConfirmButton--disabled" : ""}`}
      onClick={handleSaveTemplate}
      disabled={disabled || loading}
    >
      {loading ? (
        <>
          <span>Saving</span>
          <LoadingDots width={16} fill="white" />
        </>
      ) : (<span>{text}</span>)}
    </Button>
  );
}
